// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__PwyS3","skeleton":"icon_skeleton__9RzuG"};